import { combineReducers } from 'redux'

import { reducer as facebookMessenger } from 'apps/addNewAccount/FacebookMessenger/redux/addFbAccount'

export default combineReducers({
  facebookMessenger,
})
